var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.53.04a1.885 1.885 0 00-.951.393c-.092.073-11.338 9.914-11.43 10a2.09 2.09 0 00-.618 1.184c-.027.151-.037.45-.02.594a2.377 2.377 0 00.65 1.364c.042.04 2.577 2.259 5.634 4.93 3.057 2.67 5.6 4.894 5.65 4.943.563.54 1.34.67 2.022.34a2.025 2.025 0 001.02-1.162c.054-.172.07-.266.075-.47a1.592 1.592 0 00-.117-.695 1.884 1.884 0 00-.465-.684 1380.87 1380.87 0 00-4.998-4.395c-2.682-2.352-4.89-4.295-4.908-4.317-.057-.07-.06-.151-.01-.222.017-.023 9.64-8.474 9.892-8.686.29-.245.468-.544.542-.907.04-.198.035-.494-.012-.714-.07-.327-.265-.716-.458-.915-.411-.424-.953-.634-1.497-.582z",
    fill: "currentColor"
  })));
}
export default SvgArrowLeftBold;